module.exports = {
      id: "chevron-usage",
      viewBox: "0 0 29.4 11.4",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }